// extracted by mini-css-extract-plugin
var _1 = "sVoGVw0Ga7_nn5X2g3Ug";
var _2 = "#76F366";
var _3 = "#EB8632";
var _4 = "#ECC834";
var _5 = "#21FC87";
var _6 = "#EA4A30";
var _7 = "#C7EA45";
var _8 = "#272B2B";
var _9 = "#BDBDBD";
var _a = "#7D7D7D";
var _b = "#6A0DAD";
var _c = "#3A65FF";
var _d = "#4A90E2";
var _e = "#ffffff";
var _f = "sIPGRqSrqs1TTCct0eww";
var _10 = "c3Pbu7dEabYBSToLyepx";
var _11 = "jvS3GI0DcEYKlCS9Yvkv";
var _12 = "KtJbRAHPd0g80VgVhYj1";
var _13 = "OxLzayHLPalobg3mJ2MH";
var _14 = "zj_uJBBzKo3TeW98JWnj";
var _15 = "zeewqfqBfZFn9LBTTYox";
var _16 = "vmzQQ7oo5bU75St62hlW";
var _17 = "1200px";
var _18 = "992px";
var _19 = "1366px";
var _1a = "768px";
var _1b = "1475px";
var _1c = "576px";
var _1d = "1600px";
var _1e = "320px";
var _1f = "2500px";
var _20 = "d2DgfEuJXKIRxBNvbRvP";
var _21 = "eczHyU0ieFFXxaP_5DxK";
export { _1 as "base-link", _2 as "colorGradeEX", _3 as "colorGradeFR", _4 as "colorGradeGD", _5 as "colorGradeOU", _6 as "colorGradePR", _7 as "colorGradeVG", _8 as "colorNeutral", _9 as "colorNeutralLighest", _a as "colorNeutralLight", _b as "colorNonOwnerSweetLine", _c as "colorOwnerSweetLine", _d as "colorRegularLinks", _e as "colorWhite", _f as "iconMore", _10 as "menuItem", _11 as "menuItemIcon", _12 as "moreContainer", _13 as "pinIcon", _14 as "pinNavItem", _15 as "pinPopup", _16 as "reset-button", _17 as "screenlg", _18 as "screenmd", _19 as "screenml", _1a as "screensm", _1b as "screenxlg", _1c as "screenxs", _1d as "screenxxlg", _1e as "screenxxs", _1f as "screenxxxlg", _20 as "single-page-responsive-font-size", _21 as "textContainer" }
export default { "base-link": _1, "colorGradeEX": _2, "colorGradeFR": _3, "colorGradeGD": _4, "colorGradeOU": _5, "colorGradePR": _6, "colorGradeVG": _7, "colorNeutral": _8, "colorNeutralLighest": _9, "colorNeutralLight": _a, "colorNonOwnerSweetLine": _b, "colorOwnerSweetLine": _c, "colorRegularLinks": _d, "colorWhite": _e, "iconMore": _f, "menuItem": _10, "menuItemIcon": _11, "moreContainer": _12, "pinIcon": _13, "pinNavItem": _14, "pinPopup": _15, "reset-button": _16, "screenlg": _17, "screenmd": _18, "screenml": _19, "screensm": _1a, "screenxlg": _1b, "screenxs": _1c, "screenxxlg": _1d, "screenxxs": _1e, "screenxxxlg": _1f, "single-page-responsive-font-size": _20, "textContainer": _21 }
